import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import router from './router';
import { IonicVue } from '@ionic/vue';
import moment from 'moment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';
import { initializeAuth } from '@/composeables/useAzureAuth';
import { Capacitor } from '@capacitor/core';

/* Core CSS required for Ionic components to work properly */

import '@ionic/vue/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* TailwindCSS */
import './styles/tailwind.css';

import 'moment/dist/locale/sv';

moment.locale('sv');

const pinia = createPinia();
const app = createApp(App)
  .use(IonicVue, {
    mode: 'ios',
    animated: Capacitor.isNativePlatform(),
  })
  .use(pinia)
  .use(router);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tracePropagationTargets: ['localhost'],
  // Performance Monitoring
  tracesSampleRate: 0.02, //  Capture 100% of the transactions
  // Since @sentry/capacitor 3 the Vue app is passed through to the sibling SDK.
  // Session Replay options were dropped: @sentry/capacitor no longer accepts them,
  // and Replay was never active anyway without replayIntegration() in integrations.
  siblingOptions: {
    vueOptions: {
      app,
      attachProps: true,
      attachErrorHandler: true,
    },
  },
},
// Forward the init method from @sentry/vue
SentryVue.init
);

initializeAuth().then(() => {
  router.isReady().then(() => {
    app.mount('#app');
  });
});

defineCustomElements(window);
